export enum SimCardClassification {
  Nano = 2,
  Embedded = 3,
}
